(function addScrips() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-ad-client', 'ca-pub-8377217125784648');
    script.setAttribute('src', 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js');
    head.appendChild(script);
})();